import React, {Component} from 'react';
import { translate } from 'react-i18next';
import { functionalCriterial } from '../../libs/services';
import Button from '../../components/Button';
import LabelForm from '../../components/LabelForm';
import InputForm from '../../components/InputForm';
import PhonesData from '../components/PhonesData';
import ModalFingerprint from '../../containers/toolbar/components/ModalFingerprint';
import ModalPhoto from '../../containers/toolbar/components/ModalPhoto';

class AvatarInfo extends Component{
	constructor(props) {
		super(props);

        this.openModalFingerprint = this.openModalFingerprint.bind(this);
        this.concatGroupRH = this.concatGroupRH.bind(this);
        this.openModalPhoto = this.openModalPhoto.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.updatePhoto = this.updatePhoto.bind(this);
        this.getData = this.getData.bind(this);

		this.state = { 
	    	don_usr_ndm:{},
            photo:"",            
            folio:"",
            require_phone:false,

	    	incidents:[],	
			folioAgenda:""   
	    }
	}
	
	async componentDidMount() {
		this.props.onRef(this);

        var response = await functionalCriterial('don_usr_ndm');
        if(response){
            this.setState({ don_usr_ndm: response });
        }
	}

    componentWillUnmount() {
	    this.props.onRef(null)
	}

    handleChange(e){
        this.setState({[e.target.name]: e.target.value});
    }

    concatGroupRH(){
		var res = "";

		if(this.props.stats.lookup_rh==="POSITIVO"){
			res = this.props.stats.lookup_group+'+'
		}else if(this.props.stats.lookup_rh==="NEGATIVO"){
			res = this.props.stats.lookup_group+'-'
		}else{
			res = this.props.stats.lookup_group+'';
		}

		return res;
	}

    openModalFingerprint(e){
		e.preventDefault();
		this.modal_fingerprint.handleShow(this.props.finger_image);
	}
	
    openModalPhoto(e){
		e.preventDefault();
		this.modal_photo.handleShow();
	}

    updatePhoto(photo){
		this.setState({photo:photo});
	}

    getData(obj){
        obj = {...obj, donor:{
                ...obj.donor,
                person:{
                    ...obj.donor.person,
                    phones:this.phone_data !== undefined ? this.phone_data.state.phonesAdded : []
                }
            },
            photo:this.state.photo.length === 0 ? '' : this.state.photo.split(',')[1]
        };

        return obj;
    }

    clearData(){
        this.setState({
            photo:"",            
            folio:"",
            require_phone:false,
			folioAgenda:""   
        });
        this.phone_data.clearData();
    }

	render(){
		const { t } = this.props;
		return(
			<div className='np-padding'>                
				{(this.props.stats.lookup_group!=="" && this.props.stats.lookup_group !== null) &&
					<div className="col-xs-12 center">
						<h2 className='group-rh'>
							{this.concatGroupRH()}
						</h2>
					</div>
				}

				<div className="col-xs-12">
                    <div className="status-bar" 
                        style={{
                            backgroundColor:this.props.stats.status_bar_color,
                            marginBottom:"5px", 
                            textAlign:"center"
                        }} >
                        <label style={{color:this.props.stats.status_bar_color !== 'lightgray' ? "white" : '#000',margin:"3px"}}>
                            {this.props.stats.status}
                        </label>
                    </div>
				</div>

				<div className="col-xs-12" style={{textAlign:"center",align:"center"}}>
                    <img 
                        className='photo-avatar' 
                        src={this.state.photo.length === 0 ? 
                            "../../default_user.jpg"
                        :
                            this.state.photo
                        }
                        alt="Foto"
                    />
		        </div>

		        <div className="col-xs-12">
		        	<div className="col-xs-10 col-sm-offset-1">
						<div style={{textAlign:"center"}} className="col-xs-12 col-sm-6">
			        		{this.props.don_hue_dig.value === "YES" &&
                                <Button 
                                    class='btn-info btn-sm btn-avatar'
                                    action={this.openModalFingerprint}
                                    text="HUELLA"
                                />
		        			}
		        		</div>
						<div className="col-xs-12 col-sm-6">
                            <Button 
                                class="btn-info btn-sm btn-second btn-avatar"
                                action={this.openModalPhoto}
                                text="FOTO"
                            />
			        	</div>
		        	</div>
		        </div>

				{this.props.from_agenda ?
					<div className="col-xs-10 col-xs-offset-1">
						<hr className="avatar-hr"/>
                        <div className='col-xs-12 col-sm-6 no-padding'>
                            <LabelForm text="No. de folio" />
                        </div>
						<div className="col-xs-6 no-padding">
                            <InputForm 
                                id="folio"
                                value={this.state.folio}
                                handleChange={this.handleChange}
                                type="number"
                                min={1}
                                disabled={true}
                            />							
						</div>
					</div>
				:<div>
					<div className="col-xs-10 col-xs-offset-1">
						<hr className="avatar-hr"/>
						<div className="col-xs-6 no-padding">
                            <LabelForm text="No. de Ofrecimiento" />
                        </div>
						<div className="col-xs-6 no-padding">
                            <InputForm 
                                id="offer_id"
                                value={this.props.offer_id}
                                handleChange={this.handleChange}
                                type="number"
                                min={1}
                                disabled={true}
                            />
						</div>
					</div>
					<div className="col-xs-10 col-xs-offset-1">
						<hr className="avatar-hr"/>
                        <div className="col-xs-6 no-padding">
                            <LabelForm text="No. de Donador" />
                        </div>
						<div className="col-xs-6 no-padding">
                            <InputForm 
                                id="donor_number"
                                value={this.props.donor_number}
                                handleChange={this.handleChange}
                                type="number"
                                min={1}
                                disabled={this.state.don_usr_ndm.value === "NO"}
                            />
						</div>
					</div>
				</div>
				}
				

				<div className="col-xs-11 form-group" style={{marginLeft:'7%'}}>
					{this.props.stats.total_donations !== 0 &&
		        	    <>
                            <hr className="avatar-hr"/>
                            <div className="col-xs-12">
                                <span className="title-avatar">
                                    {this.props.stats.date_label}
                                </span>
                            </div>
                            <div className="col-xs-12 col-sm-3 no-padding">
                                <span style={{fontSize:'.7em'}}>
                                    {this.props.stats.last_donation_date}
                                </span>
                            </div>
                            <div className='no-padding'>
                                <div className="col-xs-12 col-sm-5">
                                    <span style={{fontSize:'.7em'}}>
                                        {this.props.stats.donation_type}
                                    </span>
                                </div>
                                <div className="col-xs-12 col-sm-4 no-paddig">
                                    <span style={{fontSize:'.7em'}}>
                                        {this.props.stats.extraction_type}
                                    </span>
                                </div>
                            </div>

                            <hr className="avatar-hr"/>
	        				<div className="col-xs-12 col-md-11" style={{textAlign:'right'}}>
	        					Total ofrecimientos
			        			<span className="donations-avatar">
			        				{this.props.stats.total_offers}
			        			</span>
			        		</div>

	        				<div className="col-xs-12 col-md-11" style={{textAlign:'right'}}>
	        					{t('content.offers.form.total_donations')}:
			        			<span className="donations-avatar">
			        				{this.props.stats.total_donations}
			        			</span>
			        		</div>
			        		
			        		<div className="col-xs-12 col-md-11" style={{textAlign:'right'}}>
			        			{t('content.offers.form.last_12_months')}:
			        			<span className="donations-avatar">
			        				 {this.props.stats.total_last_year}
			        			</span>
			        		</div>
                        </>
		        	}
				</div>
                        
                {this.props.fields.map((field, i)=>
                    field.section_key === 'DONOR' ?
                        field.print ?
                            field.key === 'DONOR_PHONE' ?
                                <PhonesData key={i}
                                    require_phone={this.state.require_phone}
                                    onRef={ref => this.phone_data = ref}
                                />                                
                            :null
                        :null
                    :null
                )}

		        <ModalFingerprint {...this.props} onRef={ref => (this.modal_fingerprint = ref)} save={this.props.updateFingerprint}/>
				<ModalPhoto {...this.props} onRef={ref => (this.modal_photo = ref)} save={this.updatePhoto}/>
		    </div>
		)
	}
}

export default translate('translations')(AvatarInfo);